export default "__VITE_ASSET__3IJiqDiH__"